import { createSelector } from 'reselect';

const getStripeSupportedCountryCodes = createSelector(
  (state) => state.setting.countryCodes,
  (state) =>
    state.setting.stripeSupportedCountryCodes.map(
      (code) => typeof code === 'string' && code.toLowerCase()
    ),
  (allCountries, stripeCountries) =>
    allCountries.filter((country) => stripeCountries.includes(country.value))
);

export const settingSelectors = {
  getCountryCodes: (state) => state.setting.countryCodes,
  getUserLanguage: (state) => state.setting.userLanguage,
  getCountryPhonePrefixes: (state) => state.setting.countryPhonePrefixes,
  getSpaPhoneNumber: (state) => state.setting.phoneNumber,
  getIsTreatmentCategoryViewVisible: (state) => state.setting.isTreatmentCategoryViewVisible,
  getIsFacilityCategoryViewVisible: (state) => state.setting.isFacilityCategoryViewVisible,
  getFacilitiesMaxDaysAdvance: (state) => state.setting.maxDaysAdvanceFacilities,
  getIsSpaDayCategoryViewVisible: (state) => state.setting.isSpaDayCategoryViewVisible,
  getAreClassesVisibleToAll: (state) => state.setting.areClassesVisibleToAll,
  getIsSpaSettingsFetching: (state) => state.setting.isSpaSettingsFetching,
  getSpaTermsAndConditions: (state) => state.setting.termsAndConditions,
  getSpaDaysMaxDaysAdvance: (state) => state.setting.maxDaysAdvanceSpaDays,
  getSpaTreatmentsMaxDaysAdvance: (state) => state.setting.maxDaysAdvanceTreatments,
  getStripeSupportedCountryCodes,
};
